import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { GameProvider } from './context/GameContext';
import { ThemeProvider } from './context/ThemeContext';
import { LecturerAuthProvider } from './context/LecturerAuthContext';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { WorldMapPage } from './pages/WorldMapPage';
import { WorldCategoryPage } from './pages/WorldCategoryPage';
import { WorldDetailPage } from './pages/WorldDetailPage';
import { LevelPage } from './pages/LevelPage';
import { ProgressPage } from './pages/ProgressPage';
import { HelpPage } from './pages/HelpPage';
import { AboutPage } from './pages/AboutPage';
import { useEffect } from 'react';
import './styles/globals.css';


function App() {

  useEffect(() => {
    if (import.meta.env.PROD) {
      const script = document.createElement('script');
      script.defer = true;
      script.setAttribute('data-domain', 'rocq-game.kpi.fei.tuke.sk');
      script.src = 'https://plausible.kpi.fei.tuke.sk/js/script.js';
      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, []);

  return (
    <div className="app-root">
    <ThemeProvider>
      <LecturerAuthProvider>
        <GameProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/worlds" element={<WorldMapPage />} />
                <Route path="/worlds/category/:categoryId" element={<WorldCategoryPage />} />
                <Route path="/worlds/:worldId" element={<WorldDetailPage />} />
                <Route path="/worlds/:worldId/levels/:levelId" element={<LevelPage />} />
                <Route path="/progress" element={<ProgressPage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/about" element={<AboutPage />} />
              </Routes>
            </Layout>
            <Toaster position="top-right" />
          </BrowserRouter>
        </GameProvider>
      </LecturerAuthProvider>
    </ThemeProvider>
    </div>
  );
}

export default App;
